import { render, staticRenderFns } from "./ReviewReceipt.vue?vue&type=template&id=4832c4dd&"
import script from "./ReviewReceipt.vue?vue&type=script&lang=js&"
export * from "./ReviewReceipt.vue?vue&type=script&lang=js&"
import style0 from "./ReviewReceipt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports